import React, { createContext, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

export const MessageContext = createContext();

export const MessageProvider = ({ children }) => {
  const [message, setMessage] = useState(null);
  const [type, setType] = useState("");
  const location = useLocation();
  const [reaload, setReaload] = useState(false);

  const showSuccess = (text) => {
    setMessage(text);
    setType("success");
    setTimeout(clearMessage, 50000); 
  };

  const showError = (text) => {
    setMessage(text);
    setType("error");
    setTimeout(clearMessage, 5000); 
  };

  const clearMessage = () => {
    setMessage(null);
    setType("");
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      clearMessage();
    }, 3000); 

    return () => clearTimeout(timeoutId); 
  }, [location]);

  return (
    <MessageContext.Provider
      value={{ message, type, showSuccess, showError, clearMessage, reaload, setReaload }}
    >
      {children}
    </MessageContext.Provider>
  );
};